<div *ngIf="controlPoint" class="text-size">
    <div class=" left-side-detail p-3  shadow-right rounded-1 min-vh-100">
        <div class="mb-4">
            <strong
                class="d-flex justify-content-center w-100 title-fs mb-3 text-slide-title">{{'MENU.MEASUREMENT_POINT_DETAIL' |
                translate}}</strong>
            <div class="d-flex align-items-center">
                <a (click)="backToEventList()" class="cursor d-flex align-items-center">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                    {{ 'BUTTONS.BACK' | translate }}
                </a>
            </div>
        </div>
        <div>
            <div>
                <div class="row">
                    <div class="col-12 d-flex align-items-center">
                        <strong class="fs-6 fw-bold fs-5"> {{controlPoint.name }}</strong>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="d-flex align-items-center">
                        <span>{{controlPoint.description}}</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 d-flex align-items-center">
                        <span class="number-symbol text-muted">N<sup
                                class="symbol">o</sup>{{controlPoint.numeroPoint}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-6">
                <button type="button" class="secondary-button detail-edit-button" (click)="onModifyVibrationCp()">
                    <img src="icon/edit-pencil.svg" /> {{ 'BUTTONS.MODIFY' | translate }}
                </button>
            </div>
            <div class="col-6">
                <button type="button" class="tertiary-button" (click)="onDelete()">
                    <img src="icon/delete.svg" /> {{ 'BUTTONS.DELETE' | translate }}
                </button>
            </div>
        </div>
        <hr>
        <div class="row mt-2">
            <div class="col-6">
                <div class="text-muted">Zone</div>
                <div>{{site?.region.nom}}</div>
            </div>
            <div class="col-6">
                <div class="text-muted">{{ 'DEVICE.SITE' | translate }}</div>
                <div>{{site?.nom}}</div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-6">
                <div class="text-muted">X</div>
                <div>{{transformedCoords?.x}}</div>
            </div>
            <div class="col-6">
                <div class="text-muted">Y</div>
                <div>{{transformedCoords?.y}}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div>
                    <div class="text-muted">Z</div>
                    <div>{{controlPoint?.z}}</div>
                </div>
            </div>
        </div>
        <div class="col-6 image-container">
            <img *ngIf="imageUrl" [src]="imageUrl" alt="{{ 'MESSAGE_INFO.CAPTURED_MAP_IMAGE' | translate }}"
                class="captured-image" (click)="goToMap()" />
        </div>
        <hr>
        <div>
            <h5 (click)="toggleCurrentDevice()" class="d-flex align-items-center" style="cursor: pointer;">
                <span class="fs-6 fw-bold fs-5">{{ isEditing ? ('BUTTONS.MODIFY_DEVICE' | translate) : (device !== null
                    ? ('DEVICE.CURRENT_DEVICE' | translate) :
                    ('DEVICE.NO_DEVICE' | translate)) }}</span>
                <span class="material-icons">
                    {{ showCurrentDevice ? 'expand_less' : 'expand_more' }}
                </span>
            </h5>
            <div *ngIf="showCurrentDevice" class="border rounded p-3 shadow-sm ">
                <div *ngIf="device !== null ">
                    <div *ngIf="!isEditing" class="row align-items-center device">
                        <div class="col-9 d-flex align-items-center">
                            <img src="./icon/device.svg" style="width: 24px; height: 24px; margin-right: 15px;" />
                            <div style="padding-left: 5px;">
                                <strong class="title cursor-pointer" (click)="navigateToVibrationDetail()">{{device.serialNumber}}</strong>
                                <div class="description">{{device.model}}</div>
                            </div>
                        </div>
                        <div class="col-3 d-flex justify-content-end edit-container">
                            <a (click)="onEditDevice()">
                                <img src="icon/edit-pencil.svg" />
                            </a>
                        </div>
                        <hr style="margin-top: 20px;">
                        <div class="row">
                            <div class="col-6">
                                <div class="text-muted">{{'DEVICE.COMPANY' | translate}}</div>
                                <div>{{company.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="device === null || isEditing">
                    <span *ngIf="device === null ">{{ 'ERRORS.NO_DEVICE_LINKED_TO_CTRL_POINT' | translate }}</span>
                    <div>
                        <app-autocomplete [options]="optionsDevice"
                            placeholder="{{ 'PLACEHOLDERS.SEARCH' | translate }}"
                            (optionSelected)="onOptionDeviceSelected($event)">
                        </app-autocomplete>
                        <div class="d-flex justify-content-center gap-2">
                            <button type="button" class="primary-button" (click)="assignDeviceToCp()">
                                {{'BUTTONS.ASSIGN' | translate}}
                            </button>
                            <button type="button" class="tertiary-button" (click)="cancelModifyAssignedDevice()">
                                {{'BUTTONS.CANCEL' | translate}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>